import { render, staticRenderFns } from "./LoginPopup.vue?vue&type=template&id=244de4b9&scoped=true"
import script from "./LoginPopup.vue?vue&type=script&lang=ts"
export * from "./LoginPopup.vue?vue&type=script&lang=ts"
import style0 from "./LoginPopup.vue?vue&type=style&index=0&id=244de4b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244de4b9",
  null
  
)

export default component.exports